module.exports = __webpack_public_path__ + "media/svg/twitter-ccad8f96.svg";